var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-pha.8a71f42a.png","uri@2x": __webpack_public_path__ + "icon-pha.0280c81e.png","uri@3x": __webpack_public_path__ + "icon-pha.10157347.png",
    width: 32,
    height: 31
});